import React, { createContext, useContext, useState, useCallback } from 'react';

const PricingContext = createContext(null);

export const PricingProvider = ({ children }) => {
  const [activePricingTab, setActivePricingTab] = useState(1); // 1 = Self Filing, 2 = Attorney-Led
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [selectedPackageTitle, setSelectedPackageTitle] = useState('');
  const [selectedPackageAmount, setSelectedPackageAmount] = useState('');

  // tmSignUpType is derived from activePricingTab
  const tmSignUpType = activePricingTab;

  const switchTab = useCallback((tabNumber) => {
    setActivePricingTab(tabNumber);
    console.log('Tab switched to:', tabNumber, 'tmSignUpType:', tabNumber);
  }, []);

  const selectPackage = useCallback((packageTitle, packageAmount) => {
    setSelectedPackageTitle(packageTitle);
    setSelectedPackageAmount(packageAmount);
    setSelectedPackage({ packageTitle, packageAmount });
    console.log('Package selected:', { tmSignUpType, packageTitle, packageAmount });
  }, [tmSignUpType]);

  const resetPackageSelection = useCallback(() => {
    setSelectedPackage(null);
    setSelectedPackageTitle('');
    setSelectedPackageAmount('');
  }, []);

  const getDefaultPackage = useCallback(() => {
    return {
      packageTitle: 'Essentials',
      packageAmount: '$45'
    };
  }, []);

  const value = {
    activePricingTab,
    selectedPackage,
    selectedPackageTitle,
    selectedPackageAmount,
    tmSignUpType,
    switchTab,
    selectPackage,
    resetPackageSelection,
    getDefaultPackage
  };

  return (
    <PricingContext.Provider value={value}>
      {children}
    </PricingContext.Provider>
  );
};

export const usePricing = () => {
  const context = useContext(PricingContext);
  if (!context) {
    throw new Error('usePricing must be used within a PricingProvider');
  }
  return context;
};
